// extracted by mini-css-extract-plugin
export default {"container":"dyVi1y","title":"BHjFbs","text":"fKH2Mu","mobile":"ctSIJV","subtitle":"uzLb_N"};